import {Component, Input, OnInit} from '@angular/core';
import {JsonArrayDownloaderService} from '../shared/services/json-array-downloader.service';
import {iFormDaten, iInputMitVersteckterBox, iNameEmail} from "../shared/entity/interfaces/allgemein";
import {FormControl, FormGroup, Validators} from '@angular/forms';
// import abrechnung from '../../assets/jsonFiles/abrechnung.json'
// import angabenZurProbe from '../../assets/jsonFiles/angabenZurProbe.json'
// import material from '../../assets/jsonFiles/material.json'
// import verantwortendeMitarbeiterIn from '../../assets/jsonFiles/verantwortendeMitarbeiterIn.json'
// import weitereAngaben from '../../assets/jsonFiles/weitereAngaben.json'


@Component({
  selector: 'app-informationen',
  templateUrl: './informationen.component.html',
  styleUrls: ['./informationen.component.scss'],
})
export class InformationenComponent implements OnInit {
  angabenZurProbeOptions: Array<string> = [];
  verantwortendeMitarbeiterInOptions: iNameEmail[] = [];
  // @ts-ignore
  informationenForm: FormGroup;
  abrechnungOptions: iInputMitVersteckterBox[] = [];
  abrechnungSelected: iInputMitVersteckterBox = {"label": "", "verstecktesDivAnzeigen": false};
  weitereAngabenOptions: iInputMitVersteckterBox[] = [];
  weitereAngabenSelected: iInputMitVersteckterBox = {"label": "", "verstecktesDivAnzeigen": false};
  materialOptions: iInputMitVersteckterBox[] = [];
  materialSelected: iInputMitVersteckterBox = {"label": "", "verstecktesDivAnzeigen": false};

  constructor(private jsonArrayDownloader: JsonArrayDownloaderService) {
  }


  ngOnInit() {
    this.informationenForm = new FormGroup({
      angabenZurProbe: new FormControl('', Validators.required),
      projektTitel: new FormControl('', Validators.required),
      einsenderName: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      telefon: new FormControl('', Validators.required),
      adresse: new FormControl('', Validators.required),
      verantwortlicheMitarbeitende: new FormControl('', Validators.required),
      // von: new FormControl('', Validators.required),
      von: new FormControl(''),
      // bis: new FormControl('', Validators.required),
      bis: new FormControl(''),
      // probenanzahl: new FormControl('', Validators.required),
      material: new FormControl('', Validators.required),
      // untersuchungsart: new FormControl('', Validators.required),
      abrechnung: new FormControl('', Validators.required),
      kostenstelle: new FormControl(''),
      rechnungsadresseName: new FormControl(''),
      rechnungsadresseAnschrift: new FormControl(''),
      fragestellung: new FormControl('', Validators.required),
      weitereAngaben: new FormControl(''),
      weitereAngabenSonstige: new FormControl('')
    });
    // this.angabenZurProbeOptions = angabenZurProbe
    // this.verantwortendeMitarbeiterInOptions = verantwortendeMitarbeiterIn
    // this.abrechnungOptions = abrechnung
    // this.materialOptions = material
    this.jsonArrayDownloader.jsonArrayDownload("weitereAngaben").subscribe(
      daten => this.weitereAngabenOptions = daten as iInputMitVersteckterBox[]
    );
    this.jsonArrayDownloader.jsonArrayDownload("material").subscribe(
      daten => this.materialOptions = daten as iInputMitVersteckterBox[]
    );
    this.jsonArrayDownloader.jsonArrayDownload("abrechnung").subscribe(
      daten => this.abrechnungOptions = daten as iInputMitVersteckterBox[]
    );
    this.jsonArrayDownloader.jsonArrayDownload("verantwortendeMitarbeiterIn").subscribe(
      daten => this.verantwortendeMitarbeiterInOptions = daten as iNameEmail[]
    );
    this.jsonArrayDownloader.jsonArrayDownload("angabenZurProbe").subscribe(
      daten => this.angabenZurProbeOptions = daten as string[]
    );



  }

  public getValidationStatus(): boolean {
    this.informationenForm.markAllAsTouched()
    return this.informationenForm.valid;
  }

  public getFormValuesAndKeys(): any {
    return this.informationenForm.value;
  }
}
